import { Box } from "@mui/material";
import Header, { HEADER_HEIGHT } from "../general/header/Header";
import PanelFrame from "./PanelFrame";
import { colors } from "../../theme";

export default function Settings() {
    return (
        <Box sx={{ height: "100vh", display: "flex", flexDirection: "column", backgroundColor: colors.sidebar }}>
            <Header />
            <Box sx={{ flexGrow: 1, minHeight: `calc(100vh - ${HEADER_HEIGHT}px)`, overflow: "hidden" }}>
                <PanelFrame />
            </Box>
        </Box>
    );
}
